export const APP_NAME = 'Screen Share';

export const SESSION_LIMITS = {
  hostCount: 1,
  viewerCount: 1,
  chatMessageCodePoints: 4_000,
} as const;
